
<template>
	<div class="pages">
		<sub-ibox-title :is-show-back = false>
			<p slot="title">微商城</p>
		</sub-ibox-title>
		
		<z-tabbar :list-obj="tabbarList"></z-tabbar>
		<section>
			<transition name="fade" mode="out-in">
				<router-view class="view"></router-view>
			</transition>
		</section>
	</div>
</template>
<script>
	import { mapActions, mapState } from 'vuex'
	export default {
		name: 'VmallIndex',
		data() {
			return {
				tabbarList:[{
					title:'商城统计',
					routeName:'statistics'
				},{
					title:'商品管理',
					routeName:'vGoods'
				},{
					title:'商品分类',
					routeName:'classify'
				},{
					title:'首页轮播',
					routeName:'vBanner'
				},{
					title:'商城配置',
					routeName:'configure'
				},{
					title:'订单明细',
					routeName:'vOrder'
				}]
			}
		},
		methods: {
		}
	}
	
</script>
<style scoped lang="scss">
@import "src/assets/css/common.scss";
@media only screen and (min-width:0px) and (max-width:640px) {
	.tab-bar,.sub-ibox-title {
		min-width: px-em(1400px);
	}	
}
</style>


// WEBPACK FOOTER //
// Index.vue?acac2ba2